<template>
  <div>
    <b-card-group deck>
      <b-col lg="6" class="my-1">
        <b-card
          title="CANE"
          label="Cane"
          label-cols-sm="12"
          label-size="sm"
          class="mb-0"
          style="margin-bottom: 20px"
        >
          <ul>
            <li>
              {{ dogName }}
            </li>
            <li>
              {{ dogBreed }}
            </li>
            <li>
              Taglia/Pelo: {{ dogWashGroupDesc }}
            </li>
            <li>
              Prezzo BASE: {{ dogUnitPrice }}
            </li> 
          </ul>
        </b-card>
      </b-col>
      <b-col lg="6" class="my-1">
        <b-card no-body class="overflow-hidden" style="max-width: 600px;">
          <b-row no-gutters>
            <!-- <b-col md="4"> -->
            <b-col>
              <img src="../../assets/cuccioli.png" style="max-width: 100%; max-height: 100%">
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-card-group>
    <b-table
      striped 
      hover
      :sticky-header="true"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc" 
      :items="items" 
      :filter="headerWashGroup"
      :filter-included-fields="filterOn"
      :filter-function="filterTable"
      @filtered="onFiltered"
      show-empty
      small
      responsive
    >
    <!--   stacked="sm"
      show-empty
      small
      responsive="sm"
    > -->
      <template #thead-top="">
        <b-tr>
          <b-th colspan="1"><span class="sr-only">Pacchetto</span></b-th>
          <b-th variant="secondary" colspan="1" class="text-center">Listino</b-th>
          <b-th variant="primary" colspan="1" class="text-center">Sconto</b-th>
          <b-th variant="secondary" colspan="2" class="text-center">Prezzo Netto</b-th>
          <!-- <b-th colspan="1"><span class="sr-only">Azioni</span></b-th> -->
        </b-tr>
      </template>
    </b-table>

    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only ok-title="CHIUDI"
      ok-variant="secondary" @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>

  </div>
</template>

<script>
  import { db } from '../../firebase/config.js';
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    data() {
      return {

        loading: false,
        lineItems: [],
        isBusy: false,
        shopName: '',
        dogId: '',
        dogName: '',
        dogBreed: '',
        dogSize: '',
        dogHair: '',
        dogWashPgm: '',
        dogUnitPrice: '',
        headerWashGroup: '',
        washGroupDesc: {
          '11': 'XS/S',
          '12': 'XS/M',
          '13': 'XS/L',
          '21': 'S/S',
          '22': 'S/M',
          '23': 'S/L',
          '31': 'M/S',
          '32': 'M/M',
          '33': 'M/L',
          '41': 'L/S',
          '42': 'L/M',
          '43': 'L/L',
          '51': 'XL/S',
          '52': 'XL/M',
          '53': 'XL/L',
          '61': 'XXL/S',
          '62': 'XXL/M',
          '63': 'XXL/L' 
        },
        sortBy: 'WashTot',
        sortDesc: false,
        fields: [
          { key: 'name', stickyColumn: true, label: 'Pacchetto' }, 
          { key: 'price.list', 
            label: 'package',
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2))
            }, 
            class: 'text-center' 
          },
          { key: 'price.discount', 
            label: '%',
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'percent',
              }).format((value / 100).toFixed(2))
            }, 
            class: 'text-center' 
          },
          { key: 'price.netUnit', 
            label: 'unit',
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2))
            }, 
            class: 'text-center' 
          },
          { key: 'price.net', 
            label: 'package',
            // formatter: (value, key, item) => {
            formatter: (value) => {
              return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'eur',
              }).format((value / 100).toFixed(2))
            }, 
            class: 'text-center' 
          },
        ],
        items: [],
        modes: ['single', 'multi', 'range' ],
        selectMode: 'multi',
        row: {},
        selected: [],
        filter: null,
        filterOn: ['WashGroup'],
        totalRows: 1,
        sortDirection: 'asc',
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
      }
    },
    components: {
    },
    methods: {
      filterTable(row, filter) {
        if (row.WashGroup == filter) { // || row.WashGroup == '99') {
          return true;
        } else {
          return false;
        }
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      info(title, message) {
        this.infoModal.title = title
        this.infoModal.content = message
        this.$root.$emit('bv::show::modal', this.infoModal.id)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
        this.items = []
        this.$router.push({name:'dogForm'})
      },
      reserve() {
        this.infoModal.title = 'Prenotazione 1° lavaggio SELF'
        this.infoModal.content = ''
        this.$router.push({name:'dogForm'})
      },
      ...mapMutations({
        set_sel_dog: 'SET_SEL_DOG', // map `this.set_sel_dog()` to `this.$store.commit('SET_SEL_DOG')`
        set_sel_subs: 'SET_SEL_SUBS',
        set_sel_card: 'SET_SEL_CARD',
      }),
    },
    computed: {
      ...mapGetters({
          // map `this.***` to `this.$store.getters.***`
          sel_user: "_user",
          // map `this.sel_dog` to `this.$store.getters._dog`
          sel_dog: "_dog",
      }),
    },
    created() {
      // Header data

      console.log('sel_user ->', this.sel_user)
      console.log('sel_dog ->', this.sel_dog)

      if(!this.sel_user || !this.sel_dog) {
        alert('Errore: parametri del cane non assegnati o incompleti')
        return
      }

      // Header data
      this.shopName = this.sel_user.shopName
      this.dogName = this.sel_dog.name //'CAMILLO',
      this.dogBreed = this.sel_dog.breedName //'Basset Hound',
      this.dogSize = this.sel_dog.size //2,
      this.dogHair = this.sel_dog.hair //2,
      this.dogWashPgm = this.sel_dog.washPgm //22,
      this.dogWashGroupDesc = this.washGroupDesc[this.sel_dog.washPgm]
      
      // Row data
      this.items = []
      db.collection('washGroups')
      .where('washPgm', '==', this.dogWashPgm)
      .where('orgId', '==', this.sel_user.orgId)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((group) => {
          const unitPrice = group.data().unitPrice
          this.dogUnitPrice = new Intl.NumberFormat('it-IT', {
              style: 'currency',
              currency: 'eur',
            })
            .format((unitPrice / 100).toFixed(2))

          db.collection('packages')
          //.where('orgId', '==', this.auth_user.claims.orgId)
          .get()
          .then((snapshot) => {
            snapshot.forEach((pack) => {
              const listPrice = unitPrice * pack.data().washTot
              
              const product = {
                id: group.id + '&' + pack.id,
                name: group.data().name + ' ' + pack.data().shortName,
                WashGroup: group.data().washPgm,
                WashTot: pack.data().washTot,
                WashAct: 0,
                price: {
                  id: pack.id,
                  listUnit: unitPrice,
                  list: listPrice,
                  discountType: 'pack',
                  discount: pack.data().discount_perc,
                  netUnit: Math.round(unitPrice * (1 - pack.data().discount_perc/100)),
                  net: Math.round(listPrice * (1 - pack.data().discount_perc/100)),
                }
              }
              this.items.push(product);
            })
          })
        })
      })
    },
  };
</script>

<style>
  .products {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(4, 1fr);
    margin-top: 3rem;
    margin-left: -50%;
  }

  .product img {
    width: 280px;
  }

  .product input {
    border: 1px solid #039be5;
    border-radius: 0.25rem;
    font-size: 1.125rem;
    line-height: 1.25rem;
    padding: 0.25rem;
  }
</style>
